/*
 * Data Pulse Hub — filter stack + card grid.
 * Region/area taxonomy is NOT hardcoded: it's built by reading the data-* attributes
 * off the server-rendered .dph-card elements (see sections/data-pulse-hub.liquid), so
 * it self-updates as new districts/towns/months publish. Matches the mockup's
 * state/render/pill/drawer interaction pattern; only the data source changed.
 *
 * Every class here is dph-prefixed on purpose — a first ship using bare names
 * ("grid", "card", "on", "hide"...) collided with Horizon's own theme-wide `.grid`
 * component and broke the live layout. See the comment at the top of
 * sections/data-pulse-hub.liquid for the full story.
 */
(function () {
  var root = document.querySelector('.rc-data-pulse-hub.dph-filters');
  if (!root) return;

  var REGION_ORDER = ['Central', 'East', 'North', 'North-East', 'West', 'CCR', 'RCR', 'OCR'];

  function byRegionOrder(a, b) {
    var ia = REGION_ORDER.indexOf(a), ib = REGION_ORDER.indexOf(b);
    if (ia === -1) ia = 999;
    if (ib === -1) ib = 999;
    return ia - ib;
  }

  function buildTaxonomy() {
    var cards = document.querySelectorAll('#dph-grid .dph-card');
    var tax = { hdb: {}, condo: {} };
    cards.forEach(function (card) {
      var t = card.dataset.type, region = card.dataset.region, area = card.dataset.area;
      if (!tax[t] || !region || !area) return;
      if (!tax[t][region]) tax[t][region] = {};
      tax[t][region][area] = { label: card.dataset.areaLabel || area, sub: card.dataset.sub || '' };
    });
    return tax;
  }

  var TAXONOMY = buildTaxonomy();
  var state = { propType: 'both', tag: 'all', regions: new Set(), areas: new Set() };

  function regionSetsFor(pt) {
    if (pt === 'hdb') return { hdb: TAXONOMY.hdb };
    if (pt === 'condo') return { condo: TAXONOMY.condo };
    return { hdb: TAXONOMY.hdb, condo: TAXONOMY.condo };
  }

  function toggleSet(set, val) {
    set.has(val) ? set.delete(val) : set.add(val);
  }

  function updateSpecCount() {
    var el = document.getElementById('dph-spec-count');
    if (!el) return;
    if (state.areas.size > 0) {
      el.style.display = 'inline-block';
      el.textContent = state.areas.size;
    } else {
      el.style.display = 'none';
    }
  }

  function renderRegionPills() {
    var wrap = document.getElementById('dph-region-pills');
    if (!wrap) return;
    wrap.innerHTML = '';
    var sets = regionSetsFor(state.propType);
    var keys = Object.keys(sets);
    keys.forEach(function (ctx, i) {
      Object.keys(sets[ctx]).sort(byRegionOrder).forEach(function (r) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'dph-pill';
        b.dataset.region = r;
        b.textContent = r;
        if (state.regions.has(r)) b.classList.add('dph-on');
        b.onclick = function () {
          toggleSet(state.regions, r);
          b.classList.toggle('dph-on');
          render();
        };
        wrap.appendChild(b);
      });
      if (i < keys.length - 1) {
        var div = document.createElement('span');
        div.className = 'dph-reg-divider';
        wrap.appendChild(div);
      }
    });
  }

  function renderDrawer() {
    var wrap = document.getElementById('dph-drawer-inner');
    if (!wrap) return;
    wrap.innerHTML = '';
    var sets = regionSetsFor(state.propType);
    Object.entries(sets).forEach(function (entry) {
      var ctx = entry[0], regions = entry[1];
      if (Object.keys(regions).length === 0) return;
      var setEl = document.createElement('div');
      setEl.className = 'dph-drawer-set dph-on';
      var label = document.createElement('div');
      label.className = 'dph-drawer-set-label';
      label.textContent = ctx === 'hdb' ? 'HDB Towns' : 'Private Districts';
      setEl.appendChild(label);
      var gridEl = document.createElement('div');
      gridEl.className = 'dph-drawer-grid';
      Object.keys(regions).sort(byRegionOrder).forEach(function (region) {
        var areas = regions[region];
        var g = document.createElement('div');
        g.className = 'dph-spec-group';
        var h = document.createElement('h6');
        h.textContent = region;
        g.appendChild(h);
        Object.keys(areas).sort().forEach(function (areaVal) {
          var info = areas[areaVal];
          var lbl = document.createElement('label');
          lbl.className = 'dph-spec-check';
          var cb = document.createElement('input');
          cb.type = 'checkbox';
          cb.value = areaVal;
          cb.checked = state.areas.has(areaVal);
          cb.onchange = function () {
            toggleSet(state.areas, areaVal);
            updateSpecCount();
            render();
          };
          lbl.appendChild(cb);
          var txt = document.createElement('span');
          if (info.sub) {
            txt.innerHTML = '<span class="dph-nm">' + info.label + '</span><span class="dph-sub">' + info.sub + '</span>';
          } else {
            txt.innerHTML = '<span class="dph-nm">' + info.label + '</span>';
          }
          lbl.appendChild(txt);
          g.appendChild(lbl);
        });
        gridEl.appendChild(g);
      });
      setEl.appendChild(gridEl);
      wrap.appendChild(setEl);
    });
  }

  function setTag(tag) {
    state.tag = tag;
    document.querySelectorAll('#dph-tag-pills .dph-tagpill').forEach(function (b) {
      b.classList.toggle('dph-on', b.dataset.tag === tag);
    });
  }

  function render() {
    var visible = 0;
    document.querySelectorAll('#dph-grid .dph-card').forEach(function (card) {
      var t = card.dataset.type, tag = card.dataset.tag, region = card.dataset.region, area = card.dataset.area;
      var okType = state.propType === 'both' || t === state.propType;
      var okTag = state.tag === 'all' || state.tag === tag;
      var okRegion = state.regions.size === 0 || state.regions.has(region);
      var okArea = state.areas.size === 0 || state.areas.has(area);
      var show = okType && okTag && okRegion && okArea;
      card.classList.toggle('dph-hide', !show);
      if (show) visible++;
    });
    var countEl = document.getElementById('dph-result-count');
    if (countEl) countEl.textContent = visible;
    var emptyEl = document.getElementById('dph-empty');
    if (emptyEl) emptyEl.classList.toggle('dph-show', visible === 0);
  }

  var segWrap = document.getElementById('dph-seg-proptype');
  if (segWrap) {
    segWrap.querySelectorAll('button').forEach(function (b) {
      b.onclick = function () {
        segWrap.querySelectorAll('button').forEach(function (x) { x.classList.remove('dph-on'); });
        b.classList.add('dph-on');
        state.propType = b.dataset.val;
        state.regions.clear();
        state.areas.clear();
        updateSpecCount();
        if (state.propType === 'hdb') setTag('Town Pulse');
        else if (state.propType === 'condo') setTag('District Pulse');
        else setTag('all');
        renderRegionPills();
        renderDrawer();
        render();
      };
    });
  }

  document.querySelectorAll('#dph-tag-pills .dph-tagpill').forEach(function (b) {
    b.onclick = function () {
      setTag(b.dataset.tag);
      render();
    };
  });

  var specifyToggle = document.getElementById('dph-specify-toggle');
  var drawer = document.getElementById('dph-drawer');
  if (specifyToggle && drawer) {
    specifyToggle.onclick = function () {
      specifyToggle.classList.toggle('dph-open');
      drawer.classList.toggle('dph-open');
    };
  }

  var clearAll = document.getElementById('dph-clear-all');
  if (clearAll) {
    clearAll.onclick = function () {
      state.regions.clear();
      state.areas.clear();
      setTag('all');
      document.querySelectorAll('#dph-region-pills .dph-pill').forEach(function (x) { x.classList.remove('dph-on'); });
      document.querySelectorAll('#dph-drawer-inner input').forEach(function (x) { x.checked = false; });
      updateSpecCount();
      render();
    };
  }

  renderRegionPills();
  renderDrawer();
  render();
})();
